import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import {
    WhatsappShareButton,
    WhatsappIcon,
    TelegramShareButton,
    TelegramIcon,
    TwitterShareButton,
    TwitterIcon,
    EmailShareButton,
    EmailIcon,
} from 'react-share'

import { baseShareURL } from '../../../apiService/apiService'

import './PlanShareModal.css'

const PlanShareModal = ({ planId, visible, toggle }) => {
    const getUrl = () => baseShareURL + '/#/plan/' + planId
    const getTitle = () => 'مکبر پلاس'

    return (
        <Modal isOpen={visible} toggle={toggle} className="plan-share-modal">
            <ModalHeader toggle={toggle}>اشتراک‌گذاری طراحی</ModalHeader>
            <ModalBody>
                <p>طرح خود را در شبکه‌های اجتماعی به اشتراک بگذارید</p>
                <div className="plan-share-modal__container">
                    <WhatsappShareButton
                        url={getUrl()}
                        title={getTitle()}
                        separator=":: "
                    >
                        <WhatsappIcon size={32} round />
                    </WhatsappShareButton>
                    <TelegramShareButton url={getUrl()} title={getTitle()}>
                        <TelegramIcon size={32} round />
                    </TelegramShareButton>
                    <TwitterShareButton url={getUrl()} title={getTitle()}>
                        <TwitterIcon size={32} round />
                    </TwitterShareButton>

                    <EmailShareButton
                        url={getUrl()}
                        subject={getTitle()}
                        body="body"
                    >
                        <EmailIcon size={32} round />
                    </EmailShareButton>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default PlanShareModal
